module.exports = __webpack_public_path__ + "static/img/no-batch-schedule.d407395c.png";